import * as React from 'react';

import { EFieldName } from '../../../../../../types/field';
import { EmptyField } from '../../../../../../components/Field/common';
import { FinishDateContainer } from '../../common/FinishDateContainer';
import { HouseNameFieldContainer } from '../../common/HouseNameField';
import { FloorFieldContainer } from '../../common/FloorField';
import { TitleFieldContainer } from '../../common/TitleFieldContainer';
import { TotalPriceFieldContainer } from '../../common/TotalPriceFieldContainer';
import { PriceForMeterFieldContainer } from '../../common/PriceForMeterFieldContainer';
import { WindowViewContainer } from '../../common/WindowView';
import { CallButtonFieldContainer } from '../../common/CallButtonField';
import { AddressFieldContainer } from '../../common/AddressField';
import { LocationFieldContainer } from '../../common/LocationField';
import { AreaFieldContainer } from '../../common/AreaField';
import { FinishingFieldContainer } from '../../common/FinisingField';
import { HouseCountFieldContainer } from '../../common/HouseCountField';
import { BuilderFieldContainer } from '../../common/BuilderField';
import { NewbuildingFieldContainer } from '../../common/NewbuildingFieldContainer';
import { FeaturesFieldContainer } from '../../common/FeaturesFieldContainer';
import { ParkingFieldContainer } from '../../common/ParkingField';
import { TextFieldContainer } from '../../common/TextField';

export interface IFlatSaleFieldContainerProps {
  name: EFieldName;
  published?: boolean;
}

export const FlatSaleFieldContainer: React.FC<IFlatSaleFieldContainerProps> = ({ name, published }) => {
  switch (name) {
    case EFieldName.Title:
      return <TitleFieldContainer />;
    case EFieldName.Price:
      return <TotalPriceFieldContainer />;
    case EFieldName.PriceForMeter:
      return <PriceForMeterFieldContainer />;
    case EFieldName.Contacts:
      return <CallButtonFieldContainer placeType="compareItem" />;
    case EFieldName.HouseName:
      return <HouseNameFieldContainer />;
    case EFieldName.Floor:
      return <FloorFieldContainer />;
    case EFieldName.WindowsView:
      return <WindowViewContainer />;
    case EFieldName.TotalArea:
      return <AreaFieldContainer type="total" />;
    case EFieldName.LivingArea:
      return <AreaFieldContainer type="living" />;
    case EFieldName.KitchenArea:
      return <AreaFieldContainer type="kitchen" />;
    case EFieldName.StartDate:
    case EFieldName.MaterialType:
    case EFieldName.Balconies:
    case EFieldName.BuildYear:
    case EFieldName.CategoryName:
    case EFieldName.CeilingHeight:
    case EFieldName.Lifts:
    case EFieldName.Mortgage:
    case EFieldName.RepairType:
    case EFieldName.HouseClass:
    case EFieldName.WC:
      return <TextFieldContainer type={name} />;
    case EFieldName.HouseCount:
      return <HouseCountFieldContainer />;
    case EFieldName.Finishing:
      return <FinishingFieldContainer />;
    case EFieldName.Infrastructure:
      return <FeaturesFieldContainer />;
    case EFieldName.Parking:
      return <ParkingFieldContainer />;
    case EFieldName.NewbuildingName:
      return <NewbuildingFieldContainer />;
    case EFieldName.FinishDate:
      return <FinishDateContainer />;
    case EFieldName.Address:
      return <AddressFieldContainer />;
    case EFieldName.Builder:
      return <BuilderFieldContainer />;
    case EFieldName.Location:
      return <LocationFieldContainer />;
    default:
      return <EmptyField published={published} />;
  }
};
